import { Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';

import authenticated from 'containers/Authenticated';

import Profile from 'views/Account/Profile';
import Notifications from 'views/Account/Notifications';

const NotFound = loadable(() => import('views/NotFound'));

const AccountSettingsRoutes = () => (
  <Switch>
    <Route path={`/account/profile`} component={authenticated(Profile)} exact />
    <Route path={`/account/notifications`} component={authenticated(Notifications)} exact />
    <Route path="*" component={NotFound} />
  </Switch>
);

export default AccountSettingsRoutes;
